/* eslint-disable no-console */
import Hls from 'hls.js';
import logger from 'utils/logger';

class HlsPlayer {
  constructor(audioEl) {
    this.hls = null;
    this.audioEl = audioEl;
  }

  loadUrl(streamUrl, mediaType) {
    try {
      // Stream HLS
      if (mediaType === 'application/vnd.apple.mpegurl' && Hls.isSupported()) {
        if (this.hls) {
          this.hls.stopLoad();
          this.hls.detachMedia();
          this.hls.destroy();
        }

        this.hls = new Hls();

        this.hls.loadSource(streamUrl);
        this.hls.attachMedia(this.audioEl);

        return new Promise((resolve) => {
          this.hls.on(Hls.Events.MANIFEST_PARSED, resolve);
        });
      // Play file directly (probably MP3)
      } else {
        this.audioEl.src = streamUrl;

        return new Promise((resolve) => {
          this.audioEl.addEventListener('loadedmetadata', resolve);
        });
      }
      throw new Error('Media format is not supported');
    } catch (error) {
      logger.log('HlsPlayer', error.message, error);

      throw new Error(error);
    }
  }
}

export default HlsPlayer;
